import { computed } from "vue";
import {
  FLAGS_CONFIG,
  FlagName,
  PRODUCTION_ENVS,
} from "./constants/flagsConfig";

export const useFlag = (flagName: FlagName) => {
  const feature = FLAGS_CONFIG[flagName];
  const isProd = computed(() =>
    PRODUCTION_ENVS.includes(import.meta.env.VITE_ENV_MODE),
  );

  const isFeatureAvailable = computed(() =>
    isProd.value ? feature.prod : feature.dev,
  );

  return { isFeatureAvailable };
};
